import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import useCreateBlob from '../TestResultsDocuments/useCreateBlob.hook';
import {
  downloadReport,
  clearDownloadReport,
} from '../../actions/downloadReport';
import Button from '../../../components/Button';
import { DocumentTypes } from '../TestResultsDocuments';

import styles from './index.module.scss';

const LabReportDownloadButton = ({ cta, labReport, dispatch, data, error }) => {
  // There is a case where in Test Results page, we can have 2 download buttons for reports, one in content and one in recommended actions. It was triggering double download, this ref is to avoid that.
  // only download for the button clicked
  const wasClickedRef = useRef(false);

  const { downloadDocument, downloadError } = useCreateBlob(
    data,
    labReport,
    () => {
      wasClickedRef.current = false;
      dispatch(clearDownloadReport());
    },
  );

  useEffect(() => {
    if (data && wasClickedRef.current) {
      downloadDocument();
    }
  }, [data, downloadDocument]);

  const downloadLabReport = (type, report) => {
    wasClickedRef.current = true;
    dispatch(downloadReport(type, report));
  };

  return (
    <div className={styles.wrapper}>
      <Button
        key={cta.text}
        variant={cta.variant}
        size='small'
        onClick={() => downloadLabReport(DocumentTypes.LAB_REPORT, labReport)}
      >
        {cta.text}
      </Button>
      {error ||
        (downloadError && (
          <p className={styles.error}>
            <FormattedMessage
              id='test-result.try-again-later'
              defaultMessage='Something went wrong, please try again later'
            />
          </p>
        ))}
    </div>
  );
};

LabReportDownloadButton.propTypes = {
  cta: PropTypes.object,
  labReport: PropTypes.string,
  dispatch: PropTypes.func,
  data: PropTypes.object,
  error: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  data: state.downloadReport.get('data'),
  loading: state.videoUpload.get('loading'),
  error: state.app.get('error'),
});

export default connect(mapStateToProps)(LabReportDownloadButton);
